export enum ProposalStatus {
  IN_PROGRESS = 'inProgress',
  GENERATED = 'generated',
  SOLD = 'sold',
}

export enum ProposalDocGenerationStatus {
  Not_Requested_Yet = 'not_requested',
  Complete = 'complete',
  Failed = 'failed',
  Generating = 'generating',
}

export const enum QuoteStatus {
  ContractAccepted = 'contractAccepted',
  CompanyDeclined = 'companyDeclined',
  CustomerDeclined = 'customerDeclined',
  DataGather = 'dataGather',
  Initialized = 'initialized',
  Rated = 'rated',
  ReadyForProposal = 'readyForProposal',
  Proposed = 'proposed',
  InUnderwritingReview = 'inUnderwritingReview',
  Sold = 'sold',
  UWDeclined = 'uwDeclined',
  PremiumCalculated = 'premiumCalculated',
  AllStatus = 'allStatus',
}

export const enum AgentRoleType {
  AgentOfRecord = 'AgentOfRecord',
  ServicingAgent = 'ServicingAgent',
  WritingAgent = 'WritingAgent',
}

export const enum AgentRoleTypeValue {
  AgentOfRecord = 'Agent Of Record',
  ServicingAgent = 'Servicing Agent',
  WritingAgent = 'Writing Agent',
}

export enum CoverageApplicability {
  Mandatory = 'Mandatory',
  Optional = 'Optional',
  OnDemand = 'On Demand',
  NotAllowed = 'Not Allowed',
}
